
import 'ol/ol.css';
import apply from 'ol-mapbox-style';
import Map from 'ol/Map';

// let's load the style from project
// ! Edit maastotiedot.json and replace any 7cd2ddae-9f2e-481c-99d0-404e7bc7a0b2 text (two intances) with your own api-key !
// ! Edit maastotiedot.json to apply your own styling to vector tile data !

// boundaries with raster background map
import style1 from './maastotiedot.json';
import style2 from './maastotiedot-taustakartalla.json';
import style3 from './maastotiedot-korkeusviivat.json';
import style3b from './maastotiedot-korkeusviivat-kaikki.json';


// only boundaries
//import style from './maastotiedot.json';

const styles = {
  'tausta': style1,
  'ortokuva' : style2,
  'maasto' : style3,
  'maasto-korkeusviivat': style3b
 },
 params = (new URL(document.location)).searchParams,
 style = styles[params.get('style')]||style1;



// let's create the map
const map = new Map({ target: 'map' });
apply(map, style).then(function (map) {
  // done
});

window.map=map;